import { LinearGradient } from "expo-linear-gradient";
import { VStack } from "native-base";
import React from "react";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";
import styled from "styled-components/native";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

const PromotionListItemLoading = () => {
  return (
    <VStack m="2" space={2} position="relative">
      <Loader height={30} />
      <VStack>
        <Loader height={120} />
      </VStack>
    </VStack>
  );
};

const Loader = styled(ShimmerPlaceholder)`
  width: ${({ width }) => (width ? width + "px" : "100%")};
  height: ${({ height }) => (height ? height + "px" : "100%")};
`;

export default PromotionListItemLoading;
